import { render } from "./RecordsTableNavigation.vue?vue&type=template&id=9b519e42&scoped=true"
import script from "./RecordsTableNavigation.vue?vue&type=script&lang=js"
export * from "./RecordsTableNavigation.vue?vue&type=script&lang=js"

import "./RecordsTableNavigation.vue?vue&type=style&index=0&id=9b519e42&lang=scss&scoped=true"
import "./RecordsTableNavigation.vue?vue&type=style&index=1&id=9b519e42&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.13.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b519e42"]])

export default __exports__